import { ISignInState } from '@telstra-connect/login/state';
import { ThunkAction } from 'redux-thunk';
import {updateSortingSucess} from '../actions/common';

export function updateSorting(data): ThunkAction<void, ISignInState, void> {
    return (dispatch, getState) => {
        dispatch(updateSortingSucess(data))
    }
}
